<template>
  <div id="relator-registra">
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-layout align-center justify-center>
      <v-flex lg10>
        <v-card>
          <v-container>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title
                class="indigo--text"
                v-if="tipeView != 'aprobacion'"
                >Datos Relator</v-toolbar-title
              >
              <v-toolbar-title
                class="indigo--text"
                v-if="tipeView == 'aprobacion'"
                >Gestión Capacitaciones Relator</v-toolbar-title
              >
            </v-toolbar>
            <v-form>
              <v-container>
                <v-layout>
                  <v-flex>
                    <!-- INICIO DATOS DE VISITA PADRE -->
                    <data-relator :id="id" :tipeView="tipeView"></data-relator>
                    <!-- TERMINO DATOS DE VISITA -->
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Vue from "vue";
import DataRelator from "@/modules/capacitacion/views/relator/RelatorData.vue";

import axios from "axios";

export default {
  name: "relator-registra",
  components: {
    DataRelator,
  },
  props: {},

  data: () => ({
    documentoId: "",
    id: "",
    tipeView: "",
  }),

  computed: {},
  mounted() {},
  created() {
    this.id = this.$route.params.id;
    this.tipeView = this.$route.params.tipeView;
  },

  methods: {
    volver() {
      setTimeout(() => {
        this.$router.push({
          name: "ProcesoCapacitacion",
        });
      }, 1000);
    },
  },
};
</script>
